var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrid(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "carbon:grid") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "FAVORITES",
    transform: "translate(-1177.000000, -182.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "carbon:grid",
    transform: "translate(1177.000000, 182.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "ViewBox",
    x: 0,
    y: 0,
    width: 22,
    height: 22
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58,3.3 L4.62,3.3 C3.89098413,3.3 3.3,3.89098413 3.3,4.62 L3.3,8.58 C3.3,9.30901587 3.89098413,9.9 4.62,9.9 L8.58,9.9 C9.30901587,9.9 9.9,9.30901587 9.9,8.58 L9.9,4.62 C9.9,3.89098413 9.30901587,3.3 8.58,3.3 Z M8.58,8.58 L4.62,8.58 L4.62,4.62 L8.58,4.62 L8.58,8.58 Z",
    id: "Shape",
    fill: "#E63C28",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.38,3.3 L13.42,3.3 C12.6909841,3.3 12.1,3.89098413 12.1,4.62 L12.1,8.58 C12.1,9.30901587 12.6909841,9.9 13.42,9.9 L17.38,9.9 C18.1090159,9.9 18.7,9.30901587 18.7,8.58 L18.7,4.62 C18.7,3.89098413 18.1090159,3.3 17.38,3.3 Z M17.38,8.58 L13.42,8.58 L13.42,4.62 L17.38,4.62 L17.38,8.58 Z",
    id: "Shape",
    fill: "#E63C28",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.58,12.1 L4.62,12.1 C3.89098413,12.1 3.3,12.6909841 3.3,13.42 L3.3,17.38 C3.3,18.1090159 3.89098413,18.7 4.62,18.7 L8.58,18.7 C9.30901587,18.7 9.9,18.1090159 9.9,17.38 L9.9,13.42 C9.9,12.6909841 9.30901587,12.1 8.58,12.1 Z M8.58,17.38 L4.62,17.38 L4.62,13.42 L8.58,13.42 L8.58,17.38 Z",
    id: "Shape",
    fill: "#E63C28",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.38,12.1 L13.42,12.1 C12.6909841,12.1 12.1,12.6909841 12.1,13.42 L12.1,17.38 C12.1,18.1090159 12.6909841,18.7 13.42,18.7 L17.38,18.7 C18.1090159,18.7 18.7,18.1090159 18.7,17.38 L18.7,13.42 C18.7,12.6909841 18.1090159,12.1 17.38,12.1 Z M17.38,17.38 L13.42,17.38 L13.42,13.42 L17.38,13.42 L17.38,17.38 Z",
    id: "Shape",
    fill: "#E63C28",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrid);
export default __webpack_public_path__ + "static/media/Grid.bc66ed9f0598ca77a91f09dc2b06dfde.svg";
export { ForwardRef as ReactComponent };